/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const authorStatisticsItemModelSchema = z.object({
    "nickname": z.string().describe("Никнейм автора"),
"id": z.string().uuid().describe("Идентификатор автора"),
"isCoauthor": z.boolean().describe("Является ли соавтором")
    })